import React from "react";

import { Button } from "@samskip/frontend-components";

import { useAppDispatch } from "@assets/hooks";
import { selectLanguage } from "@state/slices/userProfileSlice";
import i18next from "i18next";

const LanguageSwitcher = () => {
  const languages = [...i18next.languages].sort().reverse();
  const dispatch = useAppDispatch();

  const handleSelectLanguage = (language: string) => {
    dispatch(selectLanguage(language));
  };

  return (
    <div className="flex flex-row gap-2">
      {languages.map((lang) => (
        <Button
          className="uppercase"
          color="neutral-700"
          dataTestId={`language-${lang}-button`}
          key={lang}
          onClick={() => handleSelectLanguage(lang)}
          variant="text"
        >
          {lang}
        </Button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
